<script>
    import MenuMobile from "./MenuMobile.svelte";
    import LangSelector from "./LangSelector.svelte";

    export let menulinkWeb;
    export let text1;
    export let text2;
    export let text3;
    export let text4;
    export let menulinkhardware;
    export let menulinkautomation;
    export let menulinkCont;
    let menuToggle = false;

    function toggleMenu() {
        menuToggle = !menuToggle;
    }
</script>

<nav class="navbar navbar-expand-lg navbar-light sticky-top" id="menu">
    <div class="container">
        <a href="#logo" class="navbar-brand animate">
            <img src="https://storage.googleapis.com/cms.lobesoft.com/2019/12/2e0fe48e-pittogrammacolorato.png" height="40" alt="LOGO">
            <img src="https://storage.googleapis.com/cms.lobesoft.com/2019/12/cf376c64-logotipo.png" alt="LOGO" class="img-fluid">
        </a>
        <button on:click={toggleMenu} class="navbar-toggler" data-target="#navigation" data-control="navigation" data-toggle="collapse">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navigation">
            <ul class="nav navbar-nav pull-lg-right ml-auto">
                <li class="nav-item animate">
                    <a href="{menulinkWeb}" class="nav-link page-scroll">{text1}</a>
                </li>
                <li class="nav-item animate">
                    <a href="{menulinkhardware}" class="nav-link  page-scroll">{text2}</a>
                </li>
                <li class="nav-item animate">
                    <a href="{menulinkautomation}" class="nav-link page-scroll">{text3}</a>
                </li>
                <li class="nav-item animate">
                    <a href="{menulinkCont}" class="nav-link page-scroll">{text4}</a>
                </li>
            </ul>
        </div>
        <div class="d-none d-lg-inline" style="margin-left: 2em">
            <LangSelector languages={[{text:'Italiano',lang:'it'},{text:'English',lang:'en'}]}/>
        </div>
    </div>
</nav>

<MenuMobile onSelect={toggleMenu} active={menuToggle} links={[{href:menulinkWeb,text:text1},{href:menulinkhardware,text:text2},{href:menulinkautomation,text:text3},{href:menulinkCont,text:text4}]}/>


<style>
    *,::after,::before{box-sizing:border-box;}
    nav{display:block;}
    ul{margin-top:0;margin-bottom:1rem;}
    ul ul{margin-bottom:0;}
    a{color:#007bff;text-decoration:none;background-color:transparent;-webkit-text-decoration-skip:objects;}
    a:hover{color:#0056b3;text-decoration:underline;}
    img{vertical-align:middle;border-style:none;}
    button{border-radius:0;}
    button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;}
    button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
    button{overflow:visible;}
    button{text-transform:none;}
    button{-webkit-appearance:button;}
    button::-moz-focus-inner{padding:0;border-style:none;}
    .img-fluid{max-width:100%;height:auto;}
    .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;}
    @media (min-width:576px){
        .container{max-width:540px;}
    }
    @media (min-width:768px){
        .container{max-width:720px;}
    }
    @media (min-width:992px){
        .container{max-width:960px;}
    }
    @media (min-width:1200px){
        .container{max-width:1140px;}
    }
    .collapse{display:none;}
    .nav{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none;}
    .nav-link{display:block;padding:.5rem 1rem;}
    .nav-link:focus,.nav-link:hover{text-decoration:none;}
    .navbar{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem;}
    .navbar>.container{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;}
    .navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap;}
    .navbar-brand:focus,.navbar-brand:hover{text-decoration:none;}
    .navbar-nav{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none;}
    .navbar-nav .nav-link{padding-right:0;padding-left:0;}
    .navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}
    .navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem;}
    .navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none;}
    .navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:"";background:no-repeat center center;background-size:100% 100%;}
    @media (max-width:991.98px){
        .navbar-expand-lg>.container{padding-right:0;padding-left:0;}
    }
    @media (min-width:992px){
        .navbar-expand-lg{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;}
        .navbar-expand-lg .navbar-nav{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;}
        .navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem;}
        .navbar-expand-lg>.container{-ms-flex-wrap:nowrap;flex-wrap:nowrap;}
        .navbar-expand-lg .navbar-collapse{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto;}
        .navbar-expand-lg .navbar-toggler{display:none;}
    }
    .navbar-light .navbar-brand{color:rgba(0,0,0,.9);}
    .navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9);}
    .navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5);}
    .navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7);}
    .navbar-light .navbar-nav .nav-link.active{color:rgba(0,0,0,.9);}
    .navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1);}
    .navbar-light .navbar-toggler-icon{background-image:url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");}
    .ml-auto{margin-left:auto!important;}
    @media print{
        *,::after,::before{text-shadow:none!important;box-shadow:none!important;}
        a:not(.btn){text-decoration:underline;}
        img{page-break-inside:avoid;}
        .container{min-width:992px!important;}
        .navbar{display:none;}
    }
    /*! CSS Used from: http://zenka.mythicsdesign.com/assets/css/style.css */
    *,*::after,*::before{-webkit-box-sizing:border-box;box-sizing:border-box;}
    ::-ms-clear{display:none;}
    a,button{color:#007bff;display:inline-block;line-height:inherit;text-decoration:none;cursor:pointer;}
    a,button,img,span{-webkit-transition:all 0.3s ease 0s;-o-transition:all 0.3s ease 0s;transition:all 0.3s ease 0s;}
    *:focus{outline:none!important;}
    a:focus{color:inherit;outline:none;text-decoration:none;}
    a:hover{text-decoration:none;color:#e52f0a;}
    button{cursor:pointer;}
    ul{list-style:outside none none;margin:0;padding:0;}
    img{max-width:100%;}
    a,a:active,a:focus{color:#6f6f6f;text-decoration:none;transition-timing-function:ease-in-out;-ms-transition-timing-function:ease-in-out;-moz-transition-timing-function:ease-in-out;-webkit-transition-timing-function:ease-in-out;-o-transition-timing-function:ease-in-out;transition-duration:.2s;-ms-transition-duration:.2s;-moz-transition-duration:.2s;-webkit-transition-duration:.2s;-o-transition-duration:.2s;}
    .navbar{border:none;-webkit-transition:0.4s all ease;-o-transition:0.4s all ease;transition:0.4s all ease;background:#fff;border:none;color:#4e4e4e;font-size:15px;border:none;margin:0px auto;padding:35px 0px;}
    .navbar *{-webkit-transition:0.4s all ease;-o-transition:0.4s all ease;transition:0.4s all ease;}
    .navbar-brand{max-width:100px;}
    .navbar-brand img{max-width:100%;}
    .navbar-light .navbar-nav .nav-link{color:rgba(0, 0, 0, 1);}
    .navbar-nav>.nav-item>a{font-size:15px;font-weight:600;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:0.3px;text-align:left;color:#000000;}
    .nav>li>a{padding-right:0px;padding-left:0px;}
    .navbar-expand-lg .navbar-nav .nav-link{padding-left:50px;padding-right:0px;}
    .navbar-light .navbar-nav>.nav-item>a:hover{color:#e52f0a!important;}
    .navbar-light .navbar-nav .nav-link.active{color:#e52f0a;}
    .navbar-light .navbar-toggler{border-color:#000;}
    .navbar-light .navbar-toggler:focus,.navbar-light .navbar-toggler:hover{color:#e52f0a!important;background-color:transparent;}
    .nav-white{background-color:#fff;-webkit-box-shadow:0 2px 3px 0px rgba(0, 0, 0, 0.16);box-shadow:0 2px 3px 0px rgba(0, 0, 0, 0.16);padding:25px 0px;}
    .nav-white .navbar-nav>.nav-item>.nav-link{color:#171717;}
    .nav-white .navbar-nav>.nav-item>.nav-link.active,.nav-white .navbar-nav>.nav-item>.nav-link:focus,.nav-white .navbar-nav>.nav-item>.nav-link:hover{color:#e52f0a!important;}
    .sticky-top{position:fixed;top:0;width:100%;z-index:99999;}
    .sub-menu-parent{position:relative;}
    .drop-down::after{font-family:"FontAwesome";text-decoration:none;content:'\f107';position:absolute;margin-left:5px;-webkit-transition:all .3s ease;-o-transition:all .3s ease;transition:all .3s ease;}
    .sub-menu{opacity:1;-webkit-transform:scale(1, 0);-ms-transform:scale(1, 0);transform:scale(1, 0);padding:10px 0px;-webkit-transform-origin:top;-ms-transform-origin:top;transform-origin:top;-webkit-transition:all 300ms ease-in-out 0s;-o-transition:all 300ms ease-in-out 0s;transition:all 300ms ease-in-out 0s;z-index:100;list-style-type:none;position:absolute;top:60px;left:30px;margin:0;background-color:#fff;text-align:left;border-top:2px solid #e52f0a;padding:0;-webkit-box-shadow:0 10px 29px 0px rgba(0, 0, 0, 0.03);box-shadow:0 10px 29px 0px rgba(0, 0, 0, 0.03);}
    .sub-menu li a{display:block;padding:10px 20px;margin-right:0px;clear:both;color:#000;white-space:nowrap;font-size:15px;letter-spacing:1px;-webkit-transition:0.3s all ease-out;-o-transition:0.3s all ease-out;transition:0.3s all ease-out;}
    .sub-menu li a:hover,.sub-menu li a:focus{color:#e52f0a;}
    .sub-menu-parent:focus .sub-menu,.sub-menu-parent:hover .sub-menu{opacity:1;-webkit-transform:scale(1, 1);-ms-transform:scale(1, 1);transform:scale(1, 1);}
    /*! CSS Used from: http://zenka.mythicsdesign.com/assets/css/responsive.css */
    @media (max-width:1600px){
        .navbar{padding:10px 0px;}
    }
    @media (max-width: 1450px){
        .navbar-light .navbar-nav>.nav-item>a{font-size:16px;}
    }
    @media only screen and (max-width:1025px){
        .navbar-light .navbar-nav>.nav-item>a,.sub-menu li a{font-size:13px;}
        .navbar-brand{width:80px;margin-right:0;}
    }
    @media only screen and (max-width: 992px){
        .drop-down::after{content:none!important;}
        .sub-menu{opacity:1;-webkit-transform:scale(1, 1);-ms-transform:scale(1, 1);transform:scale(1, 1);padding:0px;position:relative;top:0px;left:0px;margin:0;border-top:0px;box-shadow:none;}
        .navbar{padding:10px;}
        .navbar-light .navbar-toggler{border-color:none;border:none;margin-right:0px;}
        .navbar-collapse{border-top:1px solid #efefef;}
        .navbar-brand{padding:10px 0px;}
        .navbar-expand-lg .navbar-nav .nav-link{padding-left:0;padding-right:0px;}
    }
</style>
